"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { Wallet2, Gift, HouseIcon, Globe } from "lucide-react";

const ICONS_MAP = {
  house: <HouseIcon className="w-6 h-6 text-sleap-gray-950 dark:text-white" />,
  globe: <Globe className="w-6 h-6 text-sleap-gray-950 dark:text-white" />,
  wallet: <Wallet2 className="w-6 h-6 text-sleap-gray-950 dark:text-white" />,
  gift: <Gift className="w-6 h-6 text-sleap-gray-950 dark:text-white" />,
};

const OfferSection = () => {
  const t = useTranslations("HomePageOfferSection");
  const features = t.raw("features");

  return (
    <section className="w-full py-8 px-4 bg-white bg-gradient-to-b from-cyan-100/0 via-cyan-100 to-cyan-100/0 dark:bg-dark dark:text-white dark:bg-none m-0 md:py-16">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col items-start gap-6 md:flex-row md:gap-8">
          {/* Left Image */}
          <div className="w-full md:w-1/2 md:max-w-[500px] overflow-hidden">
            <img
              src="/assets/v2/images/Flightshomepage1.jpg"
              alt="Travel offers illustration"
              className="w-full h-auto rounded-2xl object-cover object-center md:max-h-[600px]"
            />
          </div>

          {/* Right Content */}
          <div className="w-full md:w-1/2 flex flex-col gap-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features?.map((feature: any, index: number) => (
                <div key={index} className="flex flex-col gap-4">
                  <span className="block">
                    {ICONS_MAP[feature.icon as keyof typeof ICONS_MAP]}
                  </span>
                  <h2 className="font-semibold font-inter text-base">
                    {feature.title}
                  </h2>
                  <p className="text-sm font-inter text-sleap-gray-600 dark:text-sleap-gray-100">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
